module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/competitions/create-competition/create-competition.component.css
// module id = ./src/app/components/competitions/create-competition/create-competition.component.css
// module chunks = main